module.exports = {
    formClass:'form-horizontal'
}


/** WEBPACK FOOTER **
 ** ./src/styles/FormTemplate-style.js
 **/